import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, saveConsent } from "@/lib/consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showPrefs, setShowPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
    const openSettings = () => {
      setAnalytics(Boolean(getConsent()?.analytics));
      setShowPrefs(true);
      setVisible(true);
    };
    window.addEventListener("brox-open-cookie-settings", openSettings);
    return () => window.removeEventListener("brox-open-cookie-settings", openSettings);
  }, []);

  if (!visible) return null;

  const decide = (analyticsValue) => {
    saveConsent({ analytics: analyticsValue });
    setVisible(false);
    setShowPrefs(false);
  };

  return (
    <div className="fixed inset-x-3 bottom-24 z-[45] sm:inset-x-auto sm:bottom-6 sm:left-6 sm:max-w-md" data-testid="cookie-banner">
      <div className="border border-white/15 bg-ink-900/95 p-5 shadow-2xl backdrop-blur">
        <p className="font-display text-sm font-bold uppercase tracking-wider text-paper">Cookies</p>
        <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
          Folosim doar cookies esențiale pentru funcționarea site-ului și, cu acordul tău, măsurători
          anonime de trafic. Detalii în{" "}
          <Link to="/politica-cookies" className="text-copper underline underline-offset-2" data-testid="cookie-policy-link">
            Politica cookies
          </Link>
          .
        </p>
        {showPrefs && (
          <div className="mt-4 space-y-3 border border-white/10 bg-ink-800 p-4" data-testid="cookie-preferences-panel">
            <label className="flex items-center justify-between gap-3 text-xs text-paper/85">
              Cookies esențiale (întotdeauna active)
              <input type="checkbox" checked disabled className="h-4 w-4 shrink-0 accent-[#D96B27]" data-testid="cookie-essential-toggle" />
            </label>
            <label className="flex cursor-pointer items-center justify-between gap-3 text-xs text-paper/85">
              Măsurători anonime de trafic (Google Analytics 4)
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                className="h-4 w-4 shrink-0 accent-[#D96B27]"
                data-testid="cookie-analytics-toggle"
              />
            </label>
            <button onClick={() => decide(analytics)} className="btn-primary w-full !px-4 !py-2.5 !text-xs" data-testid="cookie-save-prefs-btn">
              SALVEAZĂ PREFERINȚE
            </button>
          </div>
        )}
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <button onClick={() => decide(true)} className="btn-primary !px-4 !py-2.5 !text-xs" data-testid="cookie-accept-btn">
            ACCEPT
          </button>
          <button onClick={() => decide(false)} className="btn-ghost !px-4 !py-2.5 !text-xs" data-testid="cookie-reject-btn">
            RESPING NON-ESENȚIALE
          </button>
          {!showPrefs && (
            <button
              onClick={() => setShowPrefs(true)}
              className="ml-auto text-xs text-muted-foreground underline underline-offset-2 transition-colors hover:text-copper"
              data-testid="cookie-prefs-btn"
            >
              PREFERINȚE
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
